module.exports = __webpack_public_path__ + "static/media/logo.91584a4a.svg";